import { render } from "./ReactivityTab.vue?vue&type=template&id=b0884a90&scoped=true"
import script from "./ReactivityTab.vue?vue&type=script&lang=js"
export * from "./ReactivityTab.vue?vue&type=script&lang=js"

import "./ReactivityTab.vue?vue&type=style&index=0&id=b0884a90&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0884a90"]])

export default __exports__